/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
import {
  FormField,
  FormControl,
  FormItem,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { Label } from "./label";
import { BiInfoCircle } from "react-icons/bi";
import { GitFork } from "lucide-react";

export default function FormSelect({
  label,
  name,
  isRequired,
  placeholder,
  rules,
  id,
  text,
  info,
  data,
  disabled,
  errors,
  control,
  dropdownProps,
  labelStyle,
  tooltip,
  details,
  hideIcons,
}) {
  return (
    <FormField
      control={control}
      name={name}
      rules={rules ? { ...rules } : {}}
      render={({ field }) => (
        <FormItem>
          <Label
            label={label}
            isRequired={isRequired}
            style={labelStyle ? { ...labelStyle } : {}}
          />

          <div className="flex flex-col">
            <div className="flex flex-row items-center gap-[1px]">
              <Select
                onValueChange={!disabled ? field.onChange : () => {}}
                // defaultValue={field.value}
                value={field.value}
                disabled={disabled}
              >
                <FormControl>
                  <SelectTrigger
                    className={`border-secondary  w-[300px] ${
                      dropdownProps?.className ? dropdownProps.className : ""
                    }`}
                    style={
                      errors[name]
                        ? {
                            borderColor: "red",
                          }
                        : {}
                    }
                  >
                    <SelectValue placeholder={placeholder} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {data.map((elm) => (
                    <SelectItem value={elm[id]} key={elm[id]}>
                      {elm[text]}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {hideIcons ? (
                <></>
              ) : (
                <>
                  <BiInfoCircle
                    fontSize="16px"
                    style={{
                      visibility: tooltip ? "visible" : "hidden",
                      fontSize: "16px",
                      width: "1em",
                      height: "1em",
                      minWidth: "16px",
                    }}
                  />
                  <GitFork
                    title="View Records"
                    style={{
                      transform: "rotate(90deg)",
                      visibility: details ? "visible" : "hidden",
                      width: "16px",
                    }}
                  />
                </>
              )}
            </div>
            {info ? (
              <p className="text-black-500 text-xs">{info || ""}</p>
            ) : null}
            {errors ? (
              errors[name] ? (
                <p className="text-destructive text-xs">
                  {errors[name].message || "Please Select Date!"}
                </p>
              ) : (
                <></>
              )
            ) : (
              <></>
            )}
          </div>
        </FormItem>
      )}
    />
  );
}
